export default __webpack_public_path__ + "static/media/queue_bg.8f573304.png";